/* 🤖 this file was generated by script */
export const wiconRefreshCw02 = {
  name: 'refresh_cw_02',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2 14s.12.85 3.64 4.36A9 9 0 0020.78 14M2 14v6m0-6h6m14-4s-.12-.85-3.64-4.36A9 9 0 003.22 10M22 10V4m0 6h-6"/></svg>`,
};
